import React from 'react';
import {NumberField} from "react-admin";

const NumberInputDashboard = ({value, currency}) => {
  const numValue = +value;
  const color = numValue > 0 ? 'green' : numValue < 0 ? 'red' : 'rgba(0, 0, 0, 0.6)';

  if (currency === '%') {
    return (
      <span style={{ color, fontSize: '18px' }}>
        {numValue > 0 ? '+' : ''}{numValue}%
      </span>
    );
  }

  return (
    <NumberField
      source='source'
      record={{source: numValue}}
      sx={{color: currency === 'USD' ? color : 'black', fontSize: '18px'}}
      options={currency && {style: 'currency', currency: currency}}
    />
  );
};

export default NumberInputDashboard;